import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "15",
  viewBox: "0 0 18 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.9224 14.2287L16.9229 14.2282C17.1369 14.0055 17.2635 13.7001 17.2635 13.3852V4.27049C17.2635 3.93997 17.1333 3.6137 16.9021 3.37805C16.6708 3.13807 16.3604 3.00697 16.0287 3.00697H9.34307L7.18513 0.796301C7.18508 0.796242 7.18502 0.796184 7.18497 0.796125C7.06809 0.674961 6.93688 0.58271 6.78317 0.521015C6.63394 0.455388 6.47641 0.425 6.31557 0.425H2.15984C1.82817 0.425 1.51777 0.556099 1.2864 0.796071C1.05533 1.03163 0.925 1.35377 0.925 1.68852V13.3648C0.925 13.6835 1.05154 13.9934 1.27432 14.2205C1.49713 14.4477 1.79499 14.575 2.11066 14.575H16.0984C16.4095 14.575 16.7034 14.4522 16.9224 14.2287ZM2.13238 1.66107H6.3209L7.63731 3.00697H2.13238V1.66107ZM16.0561 13.3389H2.13238V4.24303H16.0561V13.3389Z",
      fill: "#949494",
      stroke: "#949494",
      "stroke-width": "0.15"
    }, null, -1)
  ])))
}
export default { render: render }